
  import api from "@/api/index"; //ABP API接口
  import { Vue, Component, Ref } from "vue-property-decorator";
  import { ElementTableView } from "@/lib/ElementTableView";

  import { MessageBox } from "element-ui";
  import enumFilter from "@/mixins/filters/enums";

  import EditPaymentCategory from "@/views/admin/components/edit-payment-category.vue";
  import { createTableTree } from "@/utils/tree";
  import {PaymentCategoryDto} from "@/api/appService";
  import {paymentCategoryScopeMapping} from "@/core/constants";
  import PagedTableView from "@/components/PagedTableView/index.vue";

  @Component({
    name: "PaymentCategoryMaintain",
    components: {PagedTableView, EditPaymentCategory },
    mixins: [enumFilter]
  })
  export default class PaymentCategoryMaintain extends Vue {
    @Ref() editForm!: EditPaymentCategory;





    queryForm = {
      categoryName:'',
      scope:''
    }


    scopeColorMapping:any = {
      Project:'primary',
      Reimbursement:'danger'
    };



    get scopeMapping(){
      return paymentCategoryScopeMapping;
    }

    // 获取表数据
    fetchData(params:any) {
      return api.paymentCategoryService.getAll(params);

    }

    // 新建
    handleCreate() {
      (this.editForm as any).show = true;
    }

    handleCreateChild(index:number, row: any){
      (this.editForm as any).show = true;
    }

    // 编辑
    handleEdit(index: number, row: any) {
      (this.editForm as any).show = true;
      (this.editForm as any).form = row;
    }

    // 删除
    async handleDelete(index: number, row: PaymentCategoryDto) {
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.paymentCategoryService.delete({ id: row.id }).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    }

    async handelOnSaved() {
    }
  }
